const BUG_REPORT_FORM = 'https://forms.gle/w4fx76hZVeePWsN1A'
const BUG_REPORT_FORM_STANFORD = 'https://docs.google.com/forms/d/e/1FAIpQLSeRw9mw1jQu-ag6icUhljKcoqPqQIKuxNzINcQ96rL4w2eAoA/viewform'

export const EXTERNAL_LINKS = {
    BUG_REPORT_FORM,
    BUG_REPORT_FORM_STANFORD,
}
